import { request } from './http'
import { ALL_PROJECTS_VALUE } from '@/lib/projectSelection'
import type { ConflictBoard, ConflictRow } from '@/types/nf'

export const conflictApi = {
  board: (projectId: string): Promise<ConflictBoard> => {
    const qs = new URLSearchParams({ project: projectId === ALL_PROJECTS_VALUE ? '' : projectId, board: '1' })
    return request<ConflictBoard>(`/v1/memory/conflicts?${qs.toString()}`)
  },
  resolve: (projectId: string, conflictId: number, action: 'cleanup' | 'recheck'): Promise<void> =>
    request<void>(`/v1/memory/conflicts/resolve?project=${encodeURIComponent(projectId)}`, {
      method: 'POST', body: { conflict_id: conflictId, action },
    }),
  list: (projectId: string, chapter?: number): Promise<ConflictRow[]> => {
    const qs = new URLSearchParams({ project: projectId === ALL_PROJECTS_VALUE ? '' : projectId })
    if (chapter !== undefined) qs.set('chapter', String(chapter))
    return request<ConflictRow[]>(`/v1/memory/conflicts?${qs.toString()}`)
  },

  /**
   * 标记例外。
   *
   * dueChapter 是【承诺给出交代的章节】，必填：过了它冲突会自动重新亮起。
   * 没有期限的例外就是永久消音，「这是我埋的伏笔」和「我不想管」会变得无法区分。
   */
  override: (projectId: string, conflictId: number, reason: string, dueChapter: number): Promise<void> =>
    request<void>(`/v1/memory/conflicts/override?project=${encodeURIComponent(projectId)}`, {
      method: 'POST',
      body: {
        conflict_id: conflictId,
        reason,
        due_chapter: dueChapter,
      },
    }),
}
